import { Popover } from '@mantine/core';

export { Popover, type PopoverProps } from '@mantine/core';

export default Popover;
